// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"eed3ff41","64":"202341e4","237":"4fcd5bd7","247":"16f07995","377":"dd88fe05","449":"191a8da8","459":"5afe41df","661":"0f01c76b","880":"44049ca0","881":"c8703857","928":"5c6ed053","997":"59343eb7"}[chunkId] + ".chunk.js";
};